import { lzIsArray } from "../services/LzType";

export default class OrderModel {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.id = model.id ? +model.id : 0;
        this.order_id = model.order_id ? model.order_id : '';
        this.customer_name = model.customer_name ? model.customer_name : '';
        this.distributor_name = model.distributor_name ? model.distributor_name : '';
        this.is_active = typeof model.is_active === 'undefined' ? true : !!model.is_active;
        this.created_at = model.created_at ? model.created_at : '';
        this.updated_at = model.updated_at ? model.updated_at : '';
        this.deleted_at = model.deleted_at ? model.deleted_at : '';
    }

    static parseArray(data) {
        if (!lzIsArray(data)) {
            return [];
        }

        const out = [];
        for (const item of data) {
            out.push(new OrderModel(item));
        }

        return out;
    }

}
